import { OnlineApplicationDetailComponent } from './../dashboard/online-application-detail/online-application-detail.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { TopbarComponent } from './shared/topbar/topbar.component';
import { DashHomeComponent } from './dash-home/dash-home.component';

import { DashboardRoutingModule} from './dashboard-routing.module';
import { AssetsComponent } from './assets/assets.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneModule } from 'ngx-dropzone';

import { NgWizardModule, NgWizardConfig, THEME } from 'ng-wizard';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { UploadDocumentComponent } from './online-application-detail/upload-document/upload-document.component';
import { ImageViewerModule } from "ngx-image-viewer";
import {
  MatCardModule,
  MatCheckboxModule,
  MatTableModule,
  MatIconModule,
  MatFormFieldModule,
  MatPaginatorModule,
  MatInputModule,
  MatSortModule
} from '@angular/material';
import { PaymentProcessComponent } from './online-application-detail/payment-process/payment-process.component';
import { DashboardNewComponent } from './dashboard-new/dashboard-new.component';
import {MatDatepickerModule} from '@angular/material';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import { ScannerComponent } from './online-application-detail/scanner/scanner.component';
import { DocumentScannerComponent } from './online-application-detail/document-scanner/document-scanner.component';
import {Ng2LoadingSpinnerModule} from 'ng2-loading-spinner';
import { VerifyDocViewComponent } from './verify-doc-view/verify-doc-view.component';
import { RequestSearchDateWiseComponent } from './request-search-date-wise/request-search-date-wise.component';
import {MatTableExporterModule} from 'mat-table-exporter';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import {ChartsModule} from 'ng2-charts';


const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};

@NgModule({
  declarations: [
    DashboardLayoutComponent,
    SidebarComponent,
    TopbarComponent,
    DashHomeComponent,
    AssetsComponent,
    OnlineApplicationDetailComponent,
    UploadDocumentComponent,
    PaymentProcessComponent,
    DashboardNewComponent,
    ScannerComponent,
    DocumentScannerComponent,
    VerifyDocViewComponent,
    RequestSearchDateWiseComponent,
    AdminDashboardComponent

  ],
    imports: [
        ImageViewerModule,
        CommonModule,
        DashboardRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        NgbNavModule,
        NgxDropzoneModule,
        NgxUiLoaderModule,
        MatDatepickerModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NgWizardModule.forRoot(ngWizardConfig),
        ImageViewerModule.forRoot(),
        NgWizardModule.forRoot(ngWizardConfig),
        MatCardModule,
        MatCheckboxModule,
        MatTableModule,
        MatIconModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatInputModule,
        MatSortModule,
        Ng2LoadingSpinnerModule.forRoot({}),
        MatTableExporterModule,
        ChartsModule
    ],
  providers: [

  ],
  entryComponents: [
    DocumentScannerComponent
  ]
})
export class DashboardModule { }
